// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    login as loginApi,
    signup as signupApi,
    forgotPassword as forgotPasswordApi,
    forgotPasswordConfirm,
    userGetKeycloak as userGetKeycloakApi
} from '../../helpers/';

import { logout as logoutKeycloakApi } from '../../helpers/authHelper.js';
import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { authApiResponseSuccess, authApiResponseError } from './actions';
import { AuthActionTypes } from './constants';

const api = new APICore();

/**
 * Login the user
 * @param {*} payload - nameOrEmail and password
 */
function* login({ payload: { nameOrEmail, password } }) {
    // const response = yield call(loginApi, { nameOrEmail, password });
    // if (response.data.metadata.status === 200) {
    //     const user = response.data.res.data;
    //     // NOTE - You can change this according to response format from your api
    //     api.setLoggedInUser(user);
    //     setAuthorization(user['token']);
    //     yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
    // } else {
    //     yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, response.data.metadata.message));
    //     api.setLoggedInUser(null);
    //     setAuthorization(null);
    // }
    try {
        const response = yield call(loginApi, { nameOrEmail, password });
        api.setLoggedInUser(response.data.user);
        api.setLoggedInUserLocal(response.data.user);
        localStorage.setItem('evoluz_token', response.data['token']);
        setAuthorization(response.data['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, response));
    } catch (error) {
        console.error('error:', error);

        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

/**
 * Logout the user
 */
function* logout() {
    try {
        // yield call(logoutApi);
        api.setLoggedInUser(null);
        api.setLoggedInUserLocal(null);
        setAuthorization(null);

        yield put(authApiResponseSuccess(AuthActionTypes.LOGOUT_USER, {}));
        yield call(logoutKeycloakApi())
        localStorage.removeItem('notificationShown');
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.LOGOUT_USER, error));
    }
}

function* signup({ payload: { fullname, email, password } }) {
    try {
        const response = yield call(signupApi, { fullname, email, password });
        const user = response.data;
        api.setLoggedInUser(user);
        setAuthorization(user['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.SIGNUP_USER, user));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.SIGNUP_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

function* forgotPassword({ payload: { username } }) {
    try {
        const response = yield call(forgotPasswordApi, { username });
        yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD, response.data));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, error));
    }
}

function* forgotPasswordChange({ payload: { data } }) {
    try {
        const response = yield call(forgotPasswordConfirm, data);
        yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD_CHANGE, response.data));
    } catch (error) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD_CHANGE, error));
    }
}

/**
 * Login the user
 * @param {*} payload - nameOrEmail and password
 */
function* loginKeycloak({payload: {token}}) {
    try {
        setAuthorization(token)
        const response = yield call(userGetKeycloakApi);
        api.setLoggedInUser(response.data.data);
        api.setLoggedInUserLocal(response.data.data);
        localStorage.setItem('evoluz_token', token);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER_KEYCLOAK, response));
    } catch (error) {
        console.error('error:', error);

        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER_KEYCLOAK, error));
        api.setLoggedInUser(null);
        api.setLoggedInUserLocal(null);
        setAuthorization(null);
    }
}

export function* watchLoginUser(): any {
    yield takeEvery(AuthActionTypes.LOGIN_USER, login);
}

export function* watchLogout(): any {
    yield takeEvery(AuthActionTypes.LOGOUT_USER, logout);
}

export function* watchSignup(): any {
    yield takeEvery(AuthActionTypes.SIGNUP_USER, signup);
}

export function* watchForgotPassword(): any {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD, forgotPassword);
}

export function* watchForgotPasswordChange(): any {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD_CHANGE, forgotPasswordChange);
}

export function* watchLoginUserKeycloak(): any {
    yield takeEvery(AuthActionTypes.LOGIN_USER_KEYCLOAK, loginKeycloak);
}

function* authSaga(): any {
    yield all([
        fork(watchLoginUser),
        fork(watchLogout),
        fork(watchSignup),
        fork(watchForgotPassword),
        fork(watchForgotPasswordChange),
        fork(watchLoginUserKeycloak)
    ]);
}

export default authSaga;
